export const buildColoursUrl = (coloursPath?: string | null): string => {
    return !coloursPath
        ? 'https://www.paris-turf.com/img/runner/default-colours.png'
        : `https://www.paris-turf.com/${coloursPath.replace('/colours/', 'colours/png/')}`
}

export const buildImgUrl = (imgPath: string): string => {
    const host = process.env.REACT_APP_CDN || ''
    return `${host}/statics/${imgPath}`
}

export const getQueryParam = (param: string): string | null => {
    const query = window.location.search
    const urlParams = new URLSearchParams(query)
    return urlParams.get(param)
}

export const getFullPath = (): string => {
    const path = window?.location.pathname + window?.location.search || ''
    return encodeURI(path)
}
